import { PATHS } from './routes.js';

export const PUBLIC_NAV = [
  { label: 'Home', to: PATHS.HOME },
  { label: 'All Products', to: PATHS.PRODUCTS },
  { label: 'Deals', to: PATHS.DEALS },
  { label: 'New Arrivals', to: PATHS.NEW_ARRIVALS },
  { label: 'Brands', to: PATHS.BRANDS },
  { label: 'Blog', to: PATHS.BLOG },
  { label: 'About', to: PATHS.ABOUT },
  { label: 'Contact', to: PATHS.CONTACT },
];

export const CUSTOMER_NAV = [
  { label: 'My Account', to: PATHS.ACCOUNT },
  { label: 'Profile', to: PATHS.CUSTOMER_PROFILE },
  { label: 'Orders', to: PATHS.CUSTOMER_ORDERS },
  { label: 'Inquiries', to: PATHS.CUSTOMER_INQUIRIES },
  { label: 'Wishlist', to: PATHS.CUSTOMER_WISHLIST },
  { label: 'Compare', to: PATHS.CUSTOMER_COMPARE },
  { label: 'Addresses', to: PATHS.CUSTOMER_ADDRESSES },
  { label: 'Change Password', to: PATHS.CUSTOMER_PASSWORD },
];

export const ADMIN_NAV = [
  { label: 'Dashboard', to: '/admin' },
  { label: 'Products', to: '/admin/products' },
  { label: 'Categories', to: '/admin/categories' },
  { label: 'Brands', to: '/admin/brands' },
  { label: 'Inventory', to: '/admin/inventory' },
  { label: 'Orders', to: '/admin/orders' },
  { label: 'Inquiries', to: '/admin/inquiries' },
  { label: 'Customers', to: '/admin/customers' },
  { label: 'Banners', to: '/admin/banners' },
  { label: 'Ads', to: '/admin/ads' },
  { label: 'Blog', to: '/admin/blog' },
  { label: 'Reports', to: '/admin/reports' },
  { label: 'SEO Settings', to: '/admin/seo' },
  { label: 'Users & Roles', to: '/admin/users' },
  { label: 'Website Settings', to: '/admin/settings' },
  { label: 'Activity Logs', to: '/admin/activity-logs' },
];

export const MARKETER_NAV = [
  { label: 'Dashboard', to: '/marketer' },

  // Blog / Content
  { label: 'Blog Posts', to: '/marketer/blog' },
  { label: 'Blog Categories', to: '/marketer/blog-categories' },
  { label: 'Blog Tags', to: '/marketer/blog-tags' },

  // SEO
  { label: 'SEO Meta Manager', to: '/marketer/seo-meta' },
  { label: 'Category SEO', to: '/marketer/seo-categories' },
  { label: 'Brand SEO', to: '/marketer/seo-brands' },
  { label: 'SEO Audit', to: '/marketer/seo-audit' },

  // Marketing Assets
  { label: 'Banners', to: '/marketer/banners' },
  { label: 'Ads', to: '/marketer/ads' },
  { label: 'Media Library', to: '/marketer/media' },
];
